<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="{model: []}"
                      :url="url"
                      :permission="{}"
                      :operate="[]"
                      :buttons="buttons"
                      :searchs="searchs"/>

        <div class="dialog">
            <el-dialog title="选择导出时间"
                       :visible.sync="exportVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm('form')"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="90px"
                             :model="form" ref="form">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
                            <el-select filterable
                                       v-model="form.agentId" clearable
                                       placeholder="请选择代理"
                                       size="medium" class="mr10 mb-10">
                                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.startTime"
                                            placeholder="开始时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                        <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
                            <el-date-picker v-model="form.endTime"
                                            placeholder="结束时间"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            type='datetime' align="right"
                                            size="medium" class="mr10 mb-10"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="exportVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submit('form')">确 定</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    import message from "../../utils/message";
    //import {excelDownload} from "../../utils/download";

    export default {
        name: "ScoreRecord",
        components: {CommonTable},
        data() {
            return {
                exportVisible: false,
                form: {
                    startTime: '',
                    endTime: '',
                    agentId: '',
                },
                agents: [],
                searchs:[{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '手机号',
                    type: 'input'
                }, {
                    name: 'type',
                    placeholder: '请选择类型',
                    type: 'select',
                    selectValue:[{
                        key: 1,
                        value: "代理钱包充值"
                    }, {
                        key: 2,
                        value: "会员推广钱包充值"
                    }, {
                        key: 3,
                        value: "会员基础钱包充值"
                    }, {
                        key: 4,
                        value: "手动会员推广钱包加款"
                    }, {
                        key: 5,
                        value: "手动会员基础钱包加款"
                    }, {
                        key: 6,
                        value: "会员推广钱包提现"
                    }, {
                        key: 7,
                        value: "会员基础钱包提现"
                    }, {
                        key: 8,
                        value: "手动添加代理积分"
                    }, {
                        key: 9,
                        value: "手动减去代理积分"
                    }, {
                        key: 10,
                        value: "添加代理扣除开版费"
                    }, {
                        key: 11,
                        value: "会员充值回滚返回积分"
                    }]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/scoreRecord/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }, {
                    field: 'dataId',
                    label: '数据ID',
                    show: true,
                    width: '',
                }, {
                    field: 'initial',
                    label: '开始积分',
                    show: true,
                    width: '',
                }, {
                    field: 'variation',
                    label: '积分变动',
                    show: true,
                    width: '',
                }, {
                    field: 'score',
                    label: '剩余积分',
                    show: true,
                    width: '',
                }, {
                    field: 'type',
                    label: '备注',
                    show: {
                        type: 'select',
                    },
                    selectData: [{
                        id: 1,
                        name: '代理钱包充值'
                    }, {
                        id: 2,
                        name: '会员推广钱包充值'
                    },{
                        id: 3,
                        name: '会员基础钱包充值'
                    }, {
                        id: 4,
                        name: '手动会员推广钱包加款'
                    }, {
                        id: 5,
                        name: '手动会员基础钱包加款'
                    }, {
                        id: 6,
                        name: '会员推广钱包提现'
                    }, {
                        id: 7,
                        name: '会员基础钱包提现'
                    }, {
                        id: 8,
                        name: '手动添加代理积分'
                    }, {
                        id: 9,
                        name: '手动减去代理积分'
                    }, {
                        id: 10,
                        name: '添加代理扣除开版费'
                    }, {
                        id: 11,
                        name: '会员充值回滚返回积分'
                    }],
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                buttons: [{
                    icon: 'el-icon-download',
                    type: 'warning',
                    text: '导出',
                    permission: 'recharge:export',
                    click: () => {
                        this.tableColumns.some(item => {
                            if (item.field == 'agentId') {
                                this.agents = item.selectData;
                            }
                        })
                        this.exportVisible = true;
                    }
                }]
            }
        },
        methods: {
            //重置表单
            resetForm(formName){
                this.$refs[formName].resetFields();
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.get({
                            url: '/scoreRecord/export',
                            data: this.form,
                            confirm: '确定导出Excel？',
                            //responseType: 'arraybuffer',
                            success: (res) => {
                                if (res.code === 0) {
                                    message.success("积分记录导出任务正在进行中");
                                    this.exportVisible = false;
                                } else {
                                    message.error(res.msg);
                                }
                                /*if (res.code) {
                                    message.error(res.msg);
                                    return;
                                }
                                excelDownload(res, "积分记录明细导出.xlsx")
                                /!*this.$msgbox({
                                    title: '下载地址',
                                    message: '下载地址为：' + res.data + '，点击确定跳转下载！'
                                }).then(() => {
                                    window.open(res.data,"_blank");
                                }).catch()*!/
                                this.exportVisible = false;*/
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
